import { RepeatIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { CommandGroup } from '@/components/ui/command';
import { useAccount } from '@/hooks/useAccount';

import { CommandLinkItem } from '../CommandLinkItem';

type AccountSwitchGroupProps = {
  onSelect: (path: string, label: string, opts?: { fullPath?: boolean }) => void;
};

export const AccountSwitchGroup = ({ onSelect }: AccountSwitchGroupProps) => {
  const { t } = useTranslation();
  const { accounts, slug, switchAccount } = useAccount();

  const otherAccounts = accounts?.filter((a) => a.slug !== slug);

  if (!otherAccounts?.length) {
    return null;
  }

  return (
    <CommandGroup heading={t('command_palette.switch_account')}>
      {otherAccounts.map((account) => (
        <CommandLinkItem
          key={account.slug}
          value={`account-switch-${account.slug}`}
          href={`/${account.slug}/`}
          keywords={[account.name, account.slug]}
          onSelect={() => {
            switchAccount(account.slug);
            onSelect(`/${account.slug}/`, account.name, { fullPath: true });
          }}
        >
          <RepeatIcon />
          <span>
            {t('command_palette.switch_account')} &rsaquo; {account.name}
          </span>
        </CommandLinkItem>
      ))}
    </CommandGroup>
  );
};
